{
    "NewuserWelcomereporting": "Welcome To Akixi Reporting",
    "NewuserWelcometoreporting": "Welcome To Reporting",
    "NewuserLetsbegin": "Let's begin.",
    "NewuserStartTutorial": "Start Tutorial",
    "NewuserSkiptutorial": "Skip Tutorial",
    "NewuserAddmodifyreport": "Add/Modify Reports...",
    "NewuserReportfiltering": "Report Filtering...",
    "NewuserAddingfields": "Adding Fields...",
    "NewuserReportquickchanges": "Report Quick Changes...",
    "NewuserFinish": "Finish",
    "NewuserNext": "Next",
    "NewuserPrevious": "Previous",
    "NAME": "LanguageNewUserTutorial"
}